<template>
  <div class="menu-wrapper" style="padding-top: 20px">
    <template v-for="item in permissionRouters">
      <!-- if one children -->
      <router-link
        v-if="hasOneShowingChildren(item.children) && !item.children[0].children && !item.meta"
        :to="item.path + '/' + item.children[0].path"
        :key="item.children[0].name"
      >
        <el-menu-item :index="item.path + '/' + item.children[0].path">
          <svg-icon
            v-if="item.children[0].meta && item.children[0].meta.icon"
            :icon-class="item.children[0].meta.icon"
          ></svg-icon>
          <span v-if="item.children[0].meta && item.children[0].meta.title" slot="title">{{
            item.children[0].meta.title
          }}</span>
        </el-menu-item>
      </router-link>

      <!-- else -->
      <el-submenu v-else :index="item.name || item.path" :key="item.name">
        <template slot="title">
          <svg-icon v-if="item.meta && item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
          <span v-if="item.meta && item.meta.title" slot="title">{{ item.meta.title }}</span>
        </template>

        <template v-for="(child, childIndex) in item.children">
          <div v-if="!child.hidden" :key="childIndex">
            <sidebar-item
              class="nest-menu"
              v-if="child.children && child.children.length > 0"
              :routes="[child]"
              :key="child.path"
            ></sidebar-item>

            <router-link v-else :to="item.path + '/' + child.path" :key="child.name">
              <el-menu-item :index="item.path + '/' + child.path">
                <span class="menu-dot" />
                <svg-icon
                  v-if="child.meta && child.meta.icon"
                  :icon-class="child.meta.icon"
                ></svg-icon>
                <span v-if="child.meta && child.meta.title" slot="title">{{
                  child.meta.title
                }}</span>
              </el-menu-item>
            </router-link>
          </div>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
import { constantRouterMap } from '@/router'

export default {
  name: 'SidebarItem',

  data() {
    return {
      routes: constantRouterMap
    }
  },

  computed: {
    permissionRouters() {
      return this.$store.getters.permissionRouters.filter((item) => !item.hidden && item.children)
    }
  },

  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter((item) => !item.hidden)

      return showingChildren.length === 1
    }
  }
}
</script>

<style lang="scss">
.sidebar-container .el-menu-item,
.sidebar-container .el-submenu .el-submenu__title {
  padding-left: 0 30px !important;
}

.sidebar-container .el-menu-item:hover,
.sidebar-container .el-submenu__title:hover {
  background: #edf6ff !important;
}

.sidebar-container .menu-dot {
  display: inline-block;
  margin-right: 10px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.sidebar-container .el-submenu .el-menu-item {
  padding-left: 20px !important;
  min-width: auto !important;
}

.sidebar-container .el-menu-item.is-active {
  background: #edf6ff !important;
  border-right: 3px solid var(--color-primary) !important;

  .svg-icon {
    fill: var(--color-primary) !important;
  }

  .menu-dot {
    background-color: var(--color-primary);
  }
}

.sidebar-container .el-submenu.is-active {
  .el-submenu__title {
    color: #263e6a !important;

    .svg-icon {
      fill: var(--color-primary) !important;
    }
  }
}
</style>
